import { MancalaMoveGenerator } from '../common/MancalaMoveGenerator';
import { AwaleRules } from './AwaleRules';
export class AwaleMoveGenerator extends MancalaMoveGenerator {
    constructor() {
        super(AwaleRules.get());
    }
}
